<template>
	<div v-if="$route.name == 'homepage'">
		<svg class="donutPos" viewBox="0 0 40 40" width="100" height="100">
			<circle
				cx="22"
				cy="18"
				r="16"
				fill="transparent"
				stroke=" #CCCCCC"
				stroke-width="3"
			/>

			<circle
				cx="22"
				cy="18"
				r="16"
				fill="transparent"
				stroke="#20639b"
				stroke-width="3"
				stroke-linecap="round"
				:stroke-dasharray="circumference"
				:stroke-dashoffset="progressOffset"
			/>
		</svg>
	</div>
	<div v-else>
		<svg
			class="donutPos"
			:class="$route.name == 'CandidateDashboard' ? 'dash-prog' : ''"
			viewBox="0 0 40 40"
			:width="$route.name == 'CandidateDashboard' && isLaptop ? '130' : '100'"
			:height="$route.name == 'CandidateDashboard' && isLaptop ? '130' : '100'"
		>
			<circle
				cx="22"
				cy="18"
				r="16"
				fill="transparent"
				stroke="#e9ecef"
				stroke-width="4"
			/>

			<circle
				cx="22"
				cy="18"
				r="16"
				fill="transparent"
				stroke="#20639b"
				stroke-width="3"
				stroke-linecap="round"
				:stroke-dasharray="circumference"
				:stroke-dashoffset="progressOffset"
			/>
		</svg>
	</div>
</template>
<script>
import commonFunc from "@/components/mixin/commonFunction.js";
export default {
	name: "DonutProgress",
	props: {
		totalProgress: {
			type: Number,
			default: 100,
		},
		progressCount: {
			type: Number,
			default: 0,
		},
		// cx:{
		//   type:Number
		// },
		// cy:{
		//   type:Number
		// },
		// r:{
		//   type:Number
		// },
		// stroke:{
		//   type:String
		// },
		// strokewidth:{
		//   type:Number
		// },
	},
	mixins: [commonFunc],
	computed: {
		percentage() {
			return (this.progressCount / this.totalProgress) * 100;
		},
		circumference() {
			return Math.floor(2 * Math.PI * 16);
		},
		progressOffset() {
			return Math.floor(
				this.circumference - (this.percentage / 100) * this.circumference
			);
		},
	},
};
</script>
<style scoped>
circle {
	transition: stroke-dashoffset 0.3s ease;
}
.donutPos {
	transform: rotate(-90deg);
}
.dash-prog {
	position: absolute;
	top: 3px;
	left: 26px;
}
</style>
